module.exports = __webpack_public_path__ + "static/media/22-2.bdbc2965.mp3";